export default {
  TEXT: 'text',
  SELECT_SINGLE: 'select_single',
  CHECKBOX_MULTI: 'check_box_multi',
  SELECT_MULTI: 'select_multi',
  CHECKBOX: 'check_box',
} as const
